// @flow

import * as React from 'react';
import { createFragmentContainer, graphql } from 'react-relay/compat';
import { AttributeTable, AttributeTableRow } from 'app/components/shared/AttributeTable';
import JobEvent from '../JobEvent';
import type { JobEventLimited_event } from './__generated__/JobEventLimited_event.graphql';

type Props = {
  event: JobEventLimited_event,
  previousTimestamp: ?string
};

function JobEventLimited({ event, previousTimestamp }: Props) {
  return (
    <JobEvent timestamp={event.timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>
        Dispatcher Limited Job
      </JobEvent.Label>
      <JobEvent.Content>
        <p>
          A matching concurrency group limit rule prevented the scheduling of this Job.
        </p>
        {event.job.concurrency ? (
          <AttributeTable>
            <AttributeTableRow title="Concurrency Group">
              <code className="dark-gray monospace">{event.job.concurrency.group}</code>
            </AttributeTableRow>
            <AttributeTableRow title="Concurrency Limit">
              <code className="dark-gray monospace">{event.job.concurrency.limit}</code>
            </AttributeTableRow>
          </AttributeTable>
        ) : null}
      </JobEvent.Content>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventLimited, {
  event: graphql`
    fragment JobEventLimited_event on JobEvent {
      ... on JobEvent {
        timestamp
        job {
          concurrency {
            group
            limit
          }
        }
      }
    }
  `
});

